/**
 * Full name with optional nickname, e.g. "Jane Smith (JSmith)" or "Jane Smith".
 */
export function formatPersonnelName(person) {
  if (!person) return '';
  const name = [person.firstName, person.lastName].filter(Boolean).join(' ').trim();
  if (person.nickname) {
    return name ? `${name} (${person.nickname})` : String(person.nickname);
  }
  return name || '';
}
